import type { WikiBlock } from "../types";

/** Judgment Selling — 유대 인앱 요약 (SSOT: trait.bond). */
export const talentBondBlocks: readonly WikiBlock[] = [
  {
    type: "callout",
    tone: "info",
    text: "부관(파티 자리 안내)을 얼마나 따를지입니다. 인형처럼 강제로 옮기지 않습니다.",
  },
  { type: "h2", text: "플레이에서 보이고 싶은 것" },
  {
    type: "ul",
    items: [
      "유대 높음 → 부관이 깔아 준 자리를 잘 따른다",
      "유대 낮음 → 내 표적·내 카이트를 고집한다",
      "너무 높으면 → 안내에 과하게 끌려 위험한 자리로 갈 수 있다",
      "힐러는 유대가 높을수록 한 명만 붙잡지 않고 나눠 힐한다",
    ],
  },
  { type: "h2", text: "디자인 의도" },
  {
    type: "ul",
    items: [
      "부관은 “여기 어때?”를 제안한다. 유대는 “그 말을 얼마나 들을까?”다",
      "“지금 피할까 / 어디로 살까”는 직감·통찰이 한다. 유대가 대신하지 않는다",
      "유대가 낮다고 해서 회피를 거부하면 안 된다. 피하기는 직감이다",
      "안전한 자리 안에서 안내를 다시 맞춘 뒤, 너무 높으면 안내에 과하게 끌린다",
    ],
  },
  { type: "h2", text: "높이면 / 낮추면" },
  {
    type: "table",
    headers: ["", "높이면", "낮추면"],
    rows: [
      ["좋은 점", "파티 자리에 잘 맞춘다 · 힐을 나눈다", "개인 플레이가 선명하다"],
      ["나쁜 점", "안내에 과하게 끌려 위험해질 수 있다", "부관 콜을 무시해 진형이 깨진다"],
      ["한마디", "같이 움직인다", "내 판단으로 움직인다"],
    ],
  },
  {
    type: "p",
    text: "부관 follow · 힐 분산 · 과준수 pull 식 → Wiki 「재능 계산식」.",
  },
];
